/* AROL: consulta el carrito actual; no crea pedidos ni envía mensajes. */
(function () {
  'use strict';
  var PHONE = '5218136289624';
  var busy = false;

  function quote(cart, links) {
    var currency = cart.currency || 'MXN';
    var money = function (cents) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: currency }).format(cents / 100) + ' ' + currency;
    };
    var lines = [links ? 'Hola, Paty. Quiero ayuda para revisar mi compra, el envío o el pago:' : 'Cotización · Electrodomésticos Olvera', ''];
    cart.items.forEach(function (item) {
      var title = item.product_title || item.title;
      if (item.variant_title && item.variant_title !== 'Default Title') title += ' · ' + item.variant_title;
      lines.push(item.quantity + ' × ' + title);
      lines.push((item.sku ? 'SKU: ' + item.sku + ' · ' : '') + money(item.final_price) + ' c/u · ' + money(item.final_line_price));
      if (links && item.url) lines.push(new URL(item.url, location.origin).href);
      lines.push('');
    });
    var discount = cart.items_subtotal_price - cart.total_price;
    if (discount > 0) lines.push('Descuento del carrito: -' + money(discount));
    lines.push('Subtotal de productos: ' + money(cart.total_price), 'Envío: por confirmar', 'Total con envío: por confirmar');
    return lines.join('\n');
  }

  function manual(root, text) {
    root.querySelector('[data-arol-cart-manual]').hidden = false;
    var field = root.querySelector('[data-arol-cart-text]');
    field.value = text;
    field.focus();
    field.select();
  }

  async function copy(text) {
    try {
      if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('clipboard');
      await navigator.clipboard.writeText(text);
      return true;
    } catch (_) {
      var field = document.createElement('textarea');
      field.value = text;
      field.style.cssText = 'position:fixed;left:0;top:0;opacity:0;pointer-events:none';
      document.body.appendChild(field);
      field.select();
      var copied = false;
      try { copied = document.execCommand('copy'); } catch (_) {}
      field.remove();
      return copied;
    }
  }

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-arol-cart-action]');
    if (!button) return;
    event.preventDefault();
    var root = button.closest('[data-arol-cart-assistance]');
    var status = root.querySelector('[data-arol-cart-status]');
    var action = button.dataset.arolCartAction;
    if (action === 'close') { root.querySelector('[data-arol-cart-manual]').hidden = true; return; }
    if (busy) return;
    busy = true;
    var buttons = document.querySelectorAll('[data-arol-cart-action]:not([data-arol-cart-action="close"])');
    buttons.forEach(function (control) { control.disabled = true; });
    status.textContent = 'Preparando el detalle del carrito…';
    // Abrir la ventana durante el clic evita el bloqueo de ventanas tras esperar la consulta.
    var popup = action === 'whatsapp' ? window.open('about:blank', '_blank') : null;
    if (popup) popup.opener = null;
    try {
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var response = await fetch(base + 'cart.js?arol=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('cart');
      var cart = await response.json();
      if (!cart.items || !cart.items.length) {
        if (popup) popup.close();
        status.textContent = 'Tu carrito está vacío. Agrega un producto para compartirlo.';
        return;
      }
      var text = quote(cart, action === 'whatsapp');
      if (action === 'copy') {
        if (await copy(text)) {
          status.textContent = 'Carrito copiado. Puedes pegarlo en WhatsApp y agregar el envío.';
          button.textContent = 'Carrito copiado';
          setTimeout(function () { button.textContent = 'Copiar carrito'; }, 3000);
        } else {
          manual(root, text);
          status.textContent = 'Selecciona y copia el texto del carrito.';
        }
      } else {
        var encoded = encodeURIComponent(text);
        // Los carritos extensos se copian completos: nunca se omiten productos del mensaje.
        if (encoded.length > 6500) {
          if (!await copy(text)) manual(root, text);
          encoded = encodeURIComponent('Hola, Paty. Quiero ayuda para revisar mi compra, el envío o el pago. Te compartiré el detalle de mi carrito en el siguiente mensaje.');
          status.textContent = 'Carrito extenso: pega el detalle completo en la conversación con Paty.';
        } else {
          status.textContent = 'Tu carrito está preparado. Revisa y envía el mensaje en WhatsApp.';
        }
        var url = 'https://wa.me/' + PHONE + '?text=' + encoded;
        if (popup) popup.location.replace(url);
        else window.location.assign(url);
      }
    } catch (_) {
      if (popup) popup.close();
      status.textContent = 'No pudimos leer el carrito. Intenta de nuevo; tus productos siguen guardados.';
    } finally {
      busy = false;
      buttons.forEach(function (control) { control.disabled = false; });
    }
  });
})();
